/** @format */

import login from 'images/homepage/navbar/usermodal/loginIcon.png';
import register from 'images/homepage/navbar/usermodal/registerIcon.png';

const LoginModalJson = {
  login: {
    img: login,
    text: "Effettua l'accesso per usufruire dei servizi del portale Comune di Milano",
    button: 'Accedi',
    url: '',
  },
  link: ['Hai dimenticato la password?'],
  link1: ['Recupera ID utente'],
};

export default LoginModalJson;
